import Flex from '@components/Flex/Flex';
import { styled } from '@mui/material';

export const TextRowContainer = styled(Flex)<{ hideBottomBorder: boolean }>(
  ({ theme, hideBottomBorder }) => ({
    borderBottom: hideBottomBorder ? 'none' : `1px solid #EAEDF1`,
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  })
);
